/**
 * Whether a beerStyles catalog row still needs an Engage style-type assignment.
 */
export function styleNeedsTypeMapping(style) {
  if (!style || typeof style !== 'object') {
    return false;
  }
  if (style.needsTypeMapping === true) {
    return true;
  }
  if (style.needsTypeMapping === false) {
    return false;
  }
  const hasType = typeof style.type === 'string' && style.type.trim().length > 0;
  const hasTypeId = typeof style.typeId === 'string' && style.typeId.trim().length > 0;
  return !hasType && !hasTypeId;
}

/**
 * Filter catalog rows that need a style type.
 */
export function filterStylesNeedingTypeMapping(beerStyles) {
  if (!Array.isArray(beerStyles)) {
    return [];
  }
  return beerStyles.filter((style) => styleNeedsTypeMapping(style));
}
